module.exports = __webpack_public_path__ + "img/design_uss.9d8091ce.jpg";